import { useLoader } from '@react-three/fiber'
import { TextureLoader } from 'three'
import { DecalGeometry } from 'three/examples/jsm/geometries/DecalGeometry'
import * as THREE from 'three'
import { useMemo } from 'react'

export default function Sticker({ mesh, position, rotation, scale, image }) {
  const texture = useLoader(TextureLoader, image)

  const decalGeometry = useMemo(() => {
    if (!mesh) return null

    return new DecalGeometry(
      mesh,
      new THREE.Vector3(...position),
      new THREE.Euler(...rotation),
      new THREE.Vector3(scale, scale, scale)
    )
  }, [mesh, position, rotation, scale])

  if (!decalGeometry) return null

  return (
    <mesh geometry={decalGeometry}>
      <meshStandardMaterial
        map={texture}
        transparent
        polygonOffset
        polygonOffsetFactor={-4}
        depthWrite={false}
      />
    </mesh>
  )
}

